import { Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'mvp-tbl',
  templateUrl: './mvp-tbl.component.html',
  styleUrls: ['./mvp-tbl.component.scss']
})
export class MvpTblComponent implements OnInit {

  @Input() data;
  levels;

  ngOnInit() {
    // this.levels = this.reshapeJson(this.data['results']);
    this.levels = this.data['results'];
  }

  reshapeJson(json): any {

    let arr = [];

    for (let i = 0, len = json.length; i < len; i++) {
      let o = {};

      //instrument name
      o['instrument_name'] = json[i]['instrumentName'];
      o['instrument_level'] = json[i]['instrumentLevel'];

      arr.push(o);
    }

    return arr;
  }

}




// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/mvp-tbl/mvp-tbl.component.ts